export default "__VITE_ASSET__fH_4mvuJ__"